import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Přehled bydlí na `/c/$orgId/$portalId/` (viz `index.tsx`), tahle routa je jen
 * pozůstatek z doby, kdy se ladil vizuál vedle katalogu. Držíme ji kvůli starým
 * odkazům a přesměrováváme, ať se `/dashboard` v URL neobjevuje.
 */
export const Route = createFileRoute('/c/$orgId/$portalId/dashboard')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/c/$orgId/$portalId', params, replace: true });
  },
});
